module.exports = __webpack_public_path__ + "img/1477420265.a4639f95.jpg";